import Fragment from 'delv/Fragment.js'

export default new Fragment(`id
executeOrder
onboardingQuestionSetId
onboardingQuestionByOnboardingQuestionId{
  id
  name
}`)
